import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsOrganizations } from '../../common/apiUrls/api-end-points-organization';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class OrganizationsService {
  private baseUrl:any; 
  private baseTranUrl:any;
  constructor(@SkipSelf() private _http: HttpClient, 
  private apiAddress: ApiEndPointsOrganizations, public env: EnvService,
    private constant: Constants) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrl = this.constant.ManageOrganizationPortNumber;
      else
      this.baseUrl = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseTranUrl = this.constant.ManageTranscationportNumber;
  else
      this.baseTranUrl = this.env.apiUrl+this.constant.ManageTranscationportNumber;
    }

  addOrganization(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addOrganization;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetActiveOfficesSuperAdmin(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.GetActiveOfficesSuperAdmin;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllOrganizations(reqVM) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getOrganization;
    return this._http.post(apiCallingURl, reqVM).pipe();
  }

  getOffices(reqVM) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getOffices;
    return this._http.post(apiCallingURl, reqVM).pipe();
  }

  updateOrganization(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateOrganization;
    return this._http.post(apiURL, reqModel).pipe();
  }
 
  getCountryList() {
    const apiCallingURl = this.baseUrl + this.apiAddress.getCountryList;
    return this._http.get(apiCallingURl).pipe();
  }

  getStateList(countryId) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getCityList(stateId) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getCityList;
    return this._http.post(apiCallingURl, stateId).pipe();
  }

  getOrganizationDomains(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.getOrganizationDomains;   
    return this._http.post(apiURL, reqModel).pipe();
  }
 
  getDatabases(): Observable<any> {
     const apiURL =  this.baseUrl + this.apiAddress.getDatabasesNames;    
     return this._http.post(apiURL,'').pipe();
   }

   getOfficeDetail(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.getOfficeDetail; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  getOrgModules(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.getOrgModules; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  activeOrgModule(reqModel): Observable<any> {  
    const apiURL =  this.baseUrl + this.apiAddress.activeOrgModule;
    return this._http.post(apiURL,reqModel).pipe();
  }

  renameOrgModule(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.renameOrgModule; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  getOfficeAdministratorList(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.getOfficeAdministratorList; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  renameOrgName(reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.renameOrgName; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  activeOrg(reqModel): Observable<any> {  
    const apiURL =  this.baseUrl + this.apiAddress.activeOrg;
    return this._http.post(apiURL,reqModel).pipe();
  }

  GetUserList(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.GetUserList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getImageUlpoadURL(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getImageUploadURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadOfficeLogos(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.UploadOfficeLogo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addSMTP(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addSMTP;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeMailConfigration(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getOfficeMailConfigration;
    return this._http.post(apiURL, reqModel).pipe();
  }

  testCustomSMTP(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.testCustomSMTP;
    return this._http.post(apiURL, reqModel).pipe();
  }

  testSmtpAPI(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.testSmtpAPI;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addEmailSignature(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addEmailSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadPortalbackgroundImage(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.uploadPortalbackgroundImage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importFormsfromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.importFormsfromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importFileManagerFoldersFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.importFileManagerFoldersFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importQuestionTemplatesFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.importQuestionTemplatesFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
   importFieldTemplatesFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.importFieldTemplatesFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

   importAIAutomationTemplateFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.importAIAutomationTemplateFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }
}
